import { all, put, takeLatest } from 'redux-saga/effects';

import { types as productTypes } from '../ducks/product';

export function * watchProduct() {
    yield takeLatest(productTypes.PRODUCT_RESET, onProductReset);
    yield takeLatest(productTypes.PRODUCT_GET, onProductGet);
    yield takeLatest(productTypes.PRODUCT_SUCCESS, onProductGetResponse);
}

export function * onProductReset({ payload }) {
    payload.method = 'get';
    return yield payload;
}

export function * onProductGet({ payload }) {
    payload.method = 'get';
    return yield payload;
}

export function * onProductGetResponse({ response, payload }) {
    if (payload.action === 'get' && response && payload.dataset === 'product') {
        return yield all([
            put({
                type: productTypes.PRODUCT_SET,
                payload: response,
            }),
        ]);
    }
}
